import React from "react";

export default function Suspended() {
  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          background: "#13293d",
          padding: 40,
          borderRadius: 12,
          width: 520,
          maxWidth: "90%",
          textAlign: "center",
          border: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <h1
          style={{
            marginBottom: 20,
            fontSize: 34,
            color: "#ffffff",
          }}
        >
          Workspace Suspended
        </h1>

        <p
          style={{
            color: "#d7e7f5",
            lineHeight: 1.6,
            marginBottom: 24,
            fontSize: 16,
          }}
        >
          This JobTelesis workspace has been suspended by the platform
          administrator.
        </p>

        <p
          style={{
            color: "#9db7d1",
            lineHeight: 1.6,
            fontSize: 15,
          }}
        >
          Please contact support or the account owner for assistance.
        </p>
      </div>
    </div>
  );
}
